import React from 'react';

function PageTitle({ title }) {
  return (
    <div className="tf-page-title style-2-edit">
      <div className="container-full">
        <div className="heading text-center">{title}</div>
      </div>
    </div>
  );
}

export default PageTitle;
